export default {
  title_danger: 'Operation Failed.',
  title_info: 'Information',
  title_success: 'Operation Successful!',
  title_warning: 'Warning'
};
